import React from 'react';
import PropTypes from 'prop-types';

import FileUploader from 'Components/Files/Uploader';
import { FILE_UPLOAD_TYPES } from 'Consts/Queries';

function Uploader({ householdId, folderId, ...rest }) {
  return (
    <FileUploader
      params={{
        type: FILE_UPLOAD_TYPES.secure,
        householdId,
        folderId,
      }}
      {...rest}
    />
  );
}
Uploader.propTypes = {
  householdId: PropTypes.number.isRequired,
  folderId: PropTypes.number.isRequired,
};

export default Uploader;
